import { CaseEditPage } from "@/features/case/pages/CaseEditPage";

export const CaseEdit = () => {
  return <CaseEditPage />;
};
